import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/allTeacher",
    name: "allTeacher",
    component: () => import("../views/allTeacher/allTeacher.vue"),
  },
  {
    path: "/realTimeStare",
    name: "realTimeStare",
    component: () => import("../views/realTimeStare/realTimeStare.vue"),
  },
  {
    path: "/hotStock",
    name: "hotStock",
    component: () => import("../views/hotStock/hotStock.vue"),
  },
  {
    path: "/newCalendar",
    name: "newCalendar",
    component: () => import("../views/newCalendar/newCalendar.vue"),
  },
  {
    path: "/researchReport",
    name: "researchReport",
    component: () => import("../views/researchReport/researchReport.vue"),
  },
  {
    path: "/leading",
    name: "leading",
    component: () => import("../views/leading/leading.vue"),
  },
  {
    path: "/order",
    name: "order",
    component: () => import("../views/order/order.vue"),
  },
  {
    path: "/orderInfo",
    name: "order-order_id",
    component: () => import("../views/order/orderInfo.vue"),
  },
  {
    path: "/sign1",
    name: "user-sign-sign1",
    component: () => import("../views/sign/sign1.vue"),
  },
  {
    path: "/sign2",
    name: "user-sign-sign2",
    component: () => import("../views/sign/sign2.vue"),
  },
  {
    path: "/sign3",
    name: "user-sign-sign3",
    component: () => import("../views/sign/sign3.vue"),
  },
  {
    path: "/sign4",
    name: "user-sign-sign4",
    component: () => import("../views/sign/sign4.vue"),
  },
  {
    path: "/sign5",
    name: "user-sign-sign5",
    component: () => import("../views/sign/sign5.vue"),
  },
  {
    path: "/signqianzi",
    name: "signqianzi",
    component: () => import("../views/sign/signqianzi.vue"),
  },
  {
    path: "/payok",
    name: "payok",
    component: () => import("../views/order/payOk.vue"),
  },
  {
    path: "/share",
    name: "share",
    component: () => import("../views/share/share.vue"),
  },
  {
    path: "/imgshare",
    name: "imgshare",
    component: () => import("../views/share/imgshare.vue"),
  },
  {
    path: "/article",
    name: "article",
    component: () => import("../views/article/article.vue"),
  },
  {
    path: "/moment",
    name: "moment",
    component: () => import("../views/moment/index.vue"),
  },
  {
    path: "/moment/collect",
    name: "momentCollect",
    component: () => import("../views/moment/collect.vue"),
  },
  {
    path: "/moment/collect-play",
    name: "momentCollectPlay",
    component: () => import("../views/moment/collect-play.vue"),
  },
  {
    path: "/moment/collection",
    name: "momentCollection",
    component: () => import("../views/moment/collection.vue"),
  }
];

const router = new VueRouter({
  routes
});

export default router;
